import { useMemo } from 'react';

export function useIsIOSSafari() {
  return useMemo(() => {
    if (typeof navigator === 'undefined') return false;

    const ua =
      navigator.userAgent || navigator.vendor || (window as any).opera || '';

    const isIOS =
      /iPad|iPhone|iPod/.test(ua) ||
      // iPadOS 13+ reports as Mac, but with touch support
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    // "Safari" should appear, but not Chrome or Firefox
    const isSafari =
      /Safari/.test(ua) &&
      !/CriOS/.test(ua) && // Chrome on iOS
      !/FxiOS/.test(ua); // Firefox on iOS

    return isIOS && isSafari;
  }, []);
}
